module.exports = __webpack_public_path__ + "img/hourglass.a741db6c.png";